import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { InputCheckbox } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './CheckBoxInput.scss';
import { ValidationPropType } from '@PetSureAustralia/petsure-react-ui-library/distLib/propTypes';

const CheckBoxInput = ({
  name,
  label,
  fieldFormContext,
  checked,
  labelCustomCssClass = '',
  inputCustomCssClass = '',
  validation,
  ...rest
}) => {
  return (
    <InputCheckbox
      {...rest}
      name={name}
      label={label}
      fieldFormContext={fieldFormContext}
      checked={fieldFormContext.watch(name)}
      onChange={() => fieldFormContext.setValue(name, !fieldFormContext.watch(name))}
      labelCustomCssClass={classNames('checkboxLabel', labelCustomCssClass)}
      inputCustomCssClass={classNames('checkboxInput', inputCustomCssClass)}
      validation={validation}
    />
  );
};

export default CheckBoxInput;

CheckBoxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  fieldFormContext: PropTypes.shape({
    watch: PropTypes.func,
    setValue: PropTypes.func
  }).isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  labelCustomCssClass: PropTypes.string,
  inputCustomCssClass: PropTypes.string,
  validation: PropTypes.shape(ValidationPropType)
};
